export const DynamicRouteBuilder = {
  creatorBySlug: (creatorSlug: string) => `/creators/${creatorSlug}`,
  communityBySlug: (creatorSlug: string, communityId: string) =>
    `/creators/${creatorSlug}/communities/${communityId}`,
  postBySlug: (creatorSlug: string, communityId: string, postId: string) =>
    `/creators/${creatorSlug}/communities/${communityId}/posts/${postId}`,
  commentBySlug: (creatorSlug: string, communityId: string, postId: string, commentId: string) =>
    `/creators/${creatorSlug}/communities/${communityId}/posts/${postId}/comments/${commentId}`,
  replyBySlug: (
    creatorSlug: string,
    communityId: string,
    postId: string,
    commentId: string,
    replyId: string,
  ) =>
    `/creators/${creatorSlug}/communities/${communityId}/posts/${postId}/comments/${commentId}/replies/${replyId}`,
  challenges: (creatorSlug: string) => `/creators/${creatorSlug}/challenges`,
  contents: (creatorSlug: string) => `/creators/${creatorSlug}/contents`,
  contentBySlug: (creatorSlug: string, contentId: string) =>
    `/creators/${creatorSlug}/contents/${contentId}`,
  badges: (creatorSlug: string) => `/creators/${creatorSlug}/badges`,
  leaderboards: (creatorSlug: string) => `/creators/${creatorSlug}/leaderboards`,
  about: (creatorSlug: string) => `/creators/${creatorSlug}/about`,
  fan: (creatorSlug: string, fanId: string) => `/creators/${creatorSlug}/fans/${fanId}`,
};
